<main id="button-panel" class="popup">
    <div class="button-grid">
        <button class="select-button" on:click={() => openPanel('players-maintenance')}>Players</button>
        <button class="select-button" on:click={() => openPanel('messages-maintenance')}>Messages</button>
        <button class="select-button" on:click={partnerMaintenance}>Partners</button>
        <button class="select-button" on:click={() => openPanel('my-name-maintenance')}>My name</button>
        <button class="select-button" on:click={() => openPanel('convention-maintenance')}>Conventions</button>


        <a href="xxx" target="_blank"><button id="help-button" class="select-button">Help</button></a>

        <button class="select-button" on:click={close}>Close</button>
    </div>
</main>

<style>
    #button-panel {
        display: none;
    }

.popup {
    background-color: #cccccc;
    border-style: solid;
    border-radius: 1vh;
    border-width: 0.25vh;
}

.button-grid {
    display: flex;
    flex-direction: column;
    padding: 1vh;
}
</style>

<script>
    import { hideMaintenancePanels } from './common';
    import { elementDisplay, getStyle, setText } from './utilities'

    function openPanel(panel_name) {
        let display = getStyle(panel_name, 'display');
        hideMaintenancePanels();
        if (display == 'grid') {
            elementDisplay(panel_name, 'none')
        } else {
            elementDisplay(panel_name, 'grid')
        }
    }

    function close() {
        elementDisplay('button-panel', 'none')
    }

    function partnerMaintenance() {
        elementDisplay('partners-maintenance', 'block')
    }

    function conventionMaintenance() {
        elementDisplay('partners-maintenance', 'flex')
    }
</script>